let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("5atoJ")).then(() => parcelRequire('ksNs6'));